<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { GanttComponent, Selection, DayMarkers, Toolbar, ExcelExport, PdfExport } from "@syncfusion/ej2-vue-gantt";
import { labelData, editingResources } from './data-source';
import api from "@/axios";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader,
    'ejs-gantt': GanttComponent
  },
  data() {

    return {
      title: "Tarefas de Projeto",
      items: [
        {
          text: "Projetos",
          href: "/"
        },
        {
          text: "Tarefas de Projeto",
          active: true
        }
      ],

      idData: 0,
      showModalprojTask: false,
      submittedTarefa: false,
      projTaskData: {},

      toolbar: [
        { text: 'Nova Tarefa', tooltipText: 'Nova Tarefa', id: 'novaTarefa', prefixIcon: 'e-icons  e-plus' },
        'ExpandAll', 'CollapseAll', "ExcelExport", "CsvExport", "PdfExport",


      ],
      data: labelData,
      height: '100%',
      taskFields: {
        id: 'TaskID',
        name: 'TaskName',
        startDate: 'StartDate',
        endDate: 'EndDate',
        duration: 'Duration',
        progress: 'Progress',
        dependency: 'Predecessor',
        resourceInfo: 'resources',
        child: 'subtasks'
      },
      columns: [
        { field: 'TaskID', headerText: 'ID', width: 75 },
        { field: 'TaskName', headerText: 'Descrição', width: 230 },
        { field: 'StartDate', headerText: 'Início' },
        { field: 'EndDate', headerText: 'Fim' },
        { field: 'Duration', headerText: 'Duração' },
        { field: 'Predecessor' },
        { field: 'Progress', headerText: 'Progresso' },
        { field: 'resources', headerText: 'Recursos' },
      ],
      resourceFields: {
        id: 'resourceId',
        name: 'resourceName'
      },
      resources: editingResources,
      labelSettings: {
        leftLabel: "leftLabelTemplate",
        rightLabel: "rightLabelTemplate",
        taskLabel: '${Progress}%'
      },
      splitterSettings: {
        position: "35%"
      },
      projectStartDate: new Date('03/25/2024'),
      projectEndDate: new Date('05/04/2024'),

    };
  },
  created() {

  },
  mounted() {

    let rota = this.$route.path
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }

    this.title = `Tarefas de Projeto (${this.idData})`

  },
  provide: {
    gantt: [DayMarkers, Selection, Toolbar, ExcelExport, PdfExport]
  },

  methods: {

    recordDoubleClick(args){
      console.log('recordDoubleClick')
      console.log(args.rowData)
      this.projTaskData = args.rowData
      this.showModalprojTask = true


    },

    confProjTask(){
      console.log('confProjTask')
      this.submittedTarefa = true
      if (this.projTaskData.descricao && this.projTaskData.inicio && this.projTaskData.fim) {
        api.post(`${getBaseUrl()}api/projtask`, {
          'projTaskData': this.projTaskData
        }).then((res) => {
          console.log('then axios separar2_0')
          console.log(res.data)

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    toolbarClick(args){
      console.log('toolbarClick')
      console.log(args.item.id)

      if (args.item.id === "GanttExport_excelexport") {
        this.$refs.gantt.ej2Instances.excelExport();
      } else if (args.item.id === "GanttExport_csvexport") {
        this.$refs.gantt.ej2Instances.csvExport();
      } else if (args.item.id === "GanttExport_pdfexport") {
        var exportProperties = {
          fitToWidthSettings: {
            isFitToWidth: true
          },
        };
        this.$refs.gantt.ej2Instances.pdfExport(exportProperties);
      } else if (args.item.id === 'novaTarefa') {

        console.log('novaTarefa')
        this.projTaskData = {}
        this.submittedTarefa = false
        this.showModalprojTask = true

      }


    }

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <div class="col-lg-12 control-section">
        <div>
          <ejs-gantt ref='gantt' id="GanttExport"
                     :dataSource="data"
                     :rowHeight="46"
                     :height="height"
                     :highlightWeekends='true'
                     :allowSelection='true'
                     :taskFields="taskFields"
                     :labelSettings="labelSettings"
                     :treeColumnIndex="1"
                     :columns="columns"
                     :splitterSettings="splitterSettings"
                     :resourceFields="resourceFields" :resources="resources"
                     :projectStartDate="projectStartDate" :projectEndDate="projectEndDate"
                     :allowExcelExport="true" :allowPdfExport="true"
                     :toolbar= "toolbar"
                     :dateFormat="'dd/MM/y'"
                     :recordDoubleClick= "recordDoubleClick"
                     v-on:toolbarClick= "toolbarClick">
            <template v-slot:leftLabelTemplate="{data}">
              <div>
                <template>{{data.TaskName}} [ {{ data.Progress }} % ]</template>
              </div>
            </template>
            <template v-slot:rightLabelTemplate="{data}">
              <div v-if="data.ganttProperties.resourceInfo">
                <span v-for="resource in data.ganttProperties.resourceInfo" :key="resource.resourceId">
                  <img :src="require('@/assets/images/users/avatar-14.png')"
                       style="height: 40px;" :alt="resource.resourceName"/>
                  <span style="marginLeft:5px;marginRight:5px">{{ resource.resourceName }}</span>
                </span>
              </div>
            </template>
          </ejs-gantt>
        </div>
      </div>

    </div>


    <b-modal size="xl"
             :title="projTaskData.id > 0 ? `Editar Tarefa (${ projTaskData.id })` : 'Criando nova Tarefa'"
             v-model="showModalprojTask" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-2">

            <div class="col-md-6">
              <label for="descricao">Descrição</label>
              <div class="position-relative">
                <input
                    id="descricao"
                    type="text"
                    v-model="projTaskData.descricao"
                    class="form-control"
                    placeholder="Descrição"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.descricao}"/>
                <div v-if="submittedTarefa && !projTaskData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label for="progresso">Progresso</label>
              <div class="position-relative">
                <input
                    id="progresso"
                    type="number"
                    max="100"
                    v-model="projTaskData.progresso"
                    class="form-control"
                    placeholder="Progresso"/>

              </div>
            </div>

          </div>

          <div class="row mb-2">

            <div class="col-md-6">
              <label for="inicio">Início</label>
              <div class="position-relative">
                <input
                    id="inicio"
                    type="datetime-local"
                    v-model="projTaskData.inicio"
                    class="form-control"
                    placeholder="Início"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.inicio}"/>
                <div v-if="submittedTarefa && !projTaskData.inicio" class="invalid-feedback">
                  <span>Campo início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label for="fim">Fim</label>
              <div class="position-relative">
                <input
                    id="fim"
                    type="datetime-local"
                    v-model="projTaskData.fim"
                    class="form-control"
                    placeholder="Fim"
                    :class="{'is-invalid': submittedTarefa && !projTaskData.fim}"/>
                <div v-if="submittedTarefa && !projTaskData.fim" class="invalid-feedback">
                  <span>Campo fim obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>




        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalprojTask = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confProjTask">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>

<style scoped>
#ToolbarTemplate  .e-quickfilter::before {
  content: "\e7ee"
}
.fabric #ToolbarTemplate /deep/  .e-quickfilter::before,
.highcontrast #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e21c';
}
.bootstrap #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e946';
}
.bootstrap4 #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e714';
}
.tailwind #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e71b';
}
.fluent #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2 #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2-dark #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2-highcontrast #ToolbarTemplate /deep/  .e-quickfilter::before
{
  content: '\e7f7';
}

</style>
